import { Heading, Text } from '@radix-ui/themes';
import { Globe } from 'lucide-react';
import { isHubertAdminUser } from 'types/user.types';
import { useThemeEditor } from '../hooks/useThemeEditor';

export const ThemesIndexPage = () => {
  const { clientId, user } = useThemeEditor();

  if (!clientId && isHubertAdminUser(user)) {
    return (
      <div className="flex flex-1 items-center justify-center bg-gray-50/50 p-20">
        <div className="max-w-md text-center">
          <div className="bg-primary/10 text-primary mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full">
            <Globe size={40} />
          </div>
          <Heading size="6">Ready to customize?</Heading>
          <Text color="gray" size="3">
            Please select a client from the sidebar to begin managing their themes.
          </Text>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 items-center justify-center bg-gray-50/50 p-20">
      <div className="max-w-md text-center">
        <Heading size="6">Select a Theme</Heading>
        <Text color="gray" size="3">
          Choose a theme from the sidebar to start editing or create a new one.
        </Text>
      </div>
    </div>
  );
};
